module.exports = __webpack_public_path__ + "static/media/new.9f2e0aa8.svg";